const md = require('markdown-it')();
const dedent = require('dedent-js');
var mila = require('markdown-it-link-attributes');

md.use(mila, {
  attrs: {
    target: '_blank',
    rel: 'noopener',
  },
});

const ProgramData = [
  {
    title: 'Prérequis et travail préparatoire',
    shortTitle: 'Travail préparatoire',
    iconName: 'travailplanet',
    colorCode: '#DC9628',
    text: md.render(
      dedent`Avant de commencer, vous devrez valider **3 prérequis essentiels** :
      - Obtenir un score minimal de **65% à notre test de logique**. Vous recevrez le lien pour le test en [postulant](/postuler).
      - Suivre notre [formation en ligne gratuite](/apprendre-a-coder-gratuitement/), spécialement conçue pour préparer nos futurs élèves.
      - Disposer d'un **ordinateur (MacBook recommandé)** pour suivre la formation.
      `
    ),
    shortText:
      'Préparez votre entrée en la matière avec une initiation aux HTML, CSS et JavaScript.',
    hashtag: ['#Motivation', '#Travail', '#Détermination', '#Préparation'],
    skills: ['HTML', 'CSS', 'JS'],
    courses: [
      'rncp6-fullTime',
      'rncp6-partTime',
      'rncp6-alternance',
    ],
    duration: {},
  },
  {
    title: 'Prérequis et travail préparatoire',
    iconName: 'travailplanet',
    colorCode: '#DC9628',
    text: md.render(
      dedent`Avant de commencer, vous devrez valider **3 prérequis essentiels** :
        - Posséder une **connexion Internet**.
        - Suivre notre [formation en ligne gratuite](/apprendre-a-coder-gratuitement/), spécialement conçue pour préparer nos futurs élèves.
        - Être équipé d'un **ordinateur (MacBook recommandé)** pour suivre la formation.`
    ),
    hashtag: ['#Motivation', '#Travail', '#Détermination', '#Préparation'],
    skills: ['HTML', 'CSS', 'JS'],
    courses: ['rncp5-e-learning'],
  },
  {
    title: 'Les bases du JavaScript',
    iconName: 'JSplanet',
    colorCode: '#868C9B',
    text: md.render(
      dedent`Dans ce module, vous écrirez vos premières lignes de **JavaScript** avec **Node.js**. Vous maîtriserez les concepts fondamentaux qui serviront de base pour toute la formation :
      - Le **Terminal**
      - Les **variables**, **conditions** et **boucles**
      - Les **fonctions** et les **callbacks**

      &nbsp;

      Ici, pas de magie : la ténacité et la volonté seront vos meilleures alliées. C'est une étape cruciale pour devenir un développeur capable de comprendre et de **débugger du code**.`
    ),
    shortText: `Commencez à coder vos premières lignes d'algo en JavaScript !`,
    hashtag: ['#Terminal', '#JavaScript', '#Node.js'],
    skills: ['Terminal', 'JS', 'Node.js'],
    courses: [
      'rncp6-fullTime',
      'rncp6-partTime',
      // 'rncp6-alternance',
      'rncp6-fullTime-landing',
      'rncp6-partTime-landing',
    ],
    duration: {
      'rncp6-fullTime': '2 semaines',
      'rncp6-partTime': '60 heures',
      'rncp6-alternance': '2 semaines',
    },
  },
  {
    title: 'Les bases du JavaScript',
    shortTitle: 'Les bases du JavaScript (70h)',
    iconName: 'JSplanet',
    colorCode: '#868C9B',
    text: md.render(
      dedent`Dans ce module, vous écrirez vos premières lignes d'algorithmes en **JavaScript**. Vous maîtriserez les concepts fondamentaux qui serviront de base pour toute la formation :
      - Le **Terminal**
      - Les **variables**, **conditions** et **boucles**
      - Les **fonctions** et les **callbacks**

      &nbsp;

      Ici, pas de magie : la ténacité et la volonté seront vos meilleures alliées. C'est une étape cruciale pour devenir un développeur capable de comprendre et de **débugger du code**.`
    ),
    shortText: `Commencez à coder vos premières lignes d'algo en JavaScript !`,
    hashtag: ['#Terminal', '#JavaScript'],
    skills: ['Terminal', 'JS'],
    courses: ['rncp5-e-learning', 'rncp5-e-learning-landing'],
    duration: {
      'rncp5-e-learning': '70 heures',
    },
  },
  {
    title: 'Serveur / API / Bases de Données',
    iconName: 'serveurplanet',
    colorCode: '#F9C38A',
    text: md.render(
      dedent`Une fois l'algorithmique maîtrisée, vous plongerez dans le **développement backend**. Vous apprendrez à construire des **serveurs** et des **APIs** ([Application Programming Interface](https://fr.wikipedia.org/wiki/Interface_de_programmation)).

      &nbsp;

      Vous aborderez des concepts avancés et utiliserez des outils professionnels tels que :
      - L'authentification des utilisateurs et la **sécurité**
      - L'envoi d'emails avec [**Mailgun**](https://www.mailgun.com/)
      - La gestion de bases de données avec **MongoDB**
      - L'upload de fichiers sur [**Cloudinary**](https://cloudinary.com/)
      - Le paiement en ligne avec [**Stripe**](https://stripe.com/fr)
      - L'hébergement de vos serveurs sur [**Northflank**](https://www.northflank.com/)`
    ),
    shortText: "Vous serez en mesure de comprendre le fonctionnement d'un serveur.",
    hashtag: ['#Express', '#Mongoose', '#MongoDBAtlas', '#Northflank'],
    skills: ['Express', 'Northflank', 'Cloudinary', 'MongoDB', 'Stripe', 'Github', 'Git'],
    mainSkills: ['Express', 'MongoDB', 'Github'],
    courses: [
      'rncp6-fullTime',
      'rncp6-partTime',
      // 'rncp6-alternance',
      'rncp6-fullTime-landing',
      'rncp6-partTime-landing',
      // 'rncp6-alternance-landing',
    ],
    duration: {
      'rncp6-fullTime': '1 semaine',
      'rncp6-partTime': '48 heures',
      'rncp6-alternance': '1 semaine',
    },
  },
  {
    title: 'Intégration HTML5 / CSS3',
    iconName: 'integrationplanet',
    colorCode: '#92A8DD',
    text: md.render(
      dedent`**HTML** et **CSS** sont les piliers de la création de pages Web. Dans ce module, vous apprendrez à :
      - Maîtriser les **meilleures pratiques de mise en page**, d'**optimisation** et de **référencement**.
      - Comprendre le concept de **DOM** ([Document Object Model](https://fr.wikipedia.org/wiki/Document_Object_Model)).
      - Implémenter vos premiers scripts côté **frontend** avec **VanillaJS**.

      &nbsp;

      Vous mettrez vos compétences en pratique en répliquant des sites populaires comme [**Marmiton**](https://www.marmiton.org/) ou [**Trip Advisor**](https://www.tripadvisor.fr/).`
    ),
    shortText: 'Vous apprendrez les meilleures pratiques de mise en page et d’optimisation Web.',
    hashtag: ['#HTML', '#CSS', '#Responsive', '#VanillaJS', '#Netlify'],
    skills: ['HTML', 'CSS', 'JS', 'Netlify'],
    mainSkills: ['HTML', 'CSS', 'JS'],
    courses: [
      'rncp6-fullTime',
      'rncp6-partTime',
      // 'rncp6-alternance',
      'rncp6-fullTime-landing',
      'rncp6-partTime-landing',
      // 'rncp6-alternance-landing',
    ],
    duration: {
      'rncp6-fullTime': '1 semaine',
      'rncp6-partTime': '48 heures',
      'rncp6-alternance': '1 semaine',
    },
  },
  {
    title: 'Interfaces Web dynamiques',
    iconName: 'siteplanet',
    colorCode: '#D75A4A',
    durationFullTime: '3 semaines',
    durationPartTime: '96 heures',
    text: md.render(
      dedent`**[React](https://fr.reactjs.org/)** est la **librairie JavaScript la plus populaire et demandée** sur le marché. Créée par **Meta**, elle est utilisée par les plus grandes entreprises tech : **Netflix, Dropbox, Airbnb, leboncoin**, etc.

      &nbsp;

      Grâce à son système de **composants**, React permet de créer rapidement des **interfaces utilisateur ultra-puissantes**. Vous mettrez en pratique vos nouvelles compétences en réalisant des clones simplifiés de sites comme :
      - [**Deliveroo**](https://deliveroo.fr/fr/)
      - [**Vinted**](https://www.vinted.fr/)
      - [**Marvel**](https://www.marvel.com/)`
    ),
    shortText:
      'Avec React et son système de composants, vous pourrez créer rapidement des interfaces ultra-puissantes',
    hashtag: ['#React', '#ViteJS', '#Node.js', '#Cloudinary'],
    skills: ['React', 'ViteJS', 'Node.js', 'Cloudinary'],
    mainSkills: ['React', 'ViteJS', 'Cloudinary'],
    courses: [
      'rncp6-fullTime',
      'rncp6-partTime',
      // 'rncp6-alternance',
      'rncp6-fullTime-landing',
      'rncp6-partTime-landing',
      // 'rncp6-alternance-landing',
    ],
    duration: {
      'rncp6-fullTime': '3 semaines',
      'rncp6-partTime': '96 heures',
      'rncp6-alternance': '3 semaines',
    },
  },
  {
    title: 'Outils & Langages',
    shortTitle: 'Outils & Langages',
    iconName: 'serveurplanet',
    colorCode: '#9C27B0',
    text: md.render(
      dedent`Maîtrisez les outils et langages essentiels pour tout développeur moderne :
      - **TypeScript** : Langage typé qui améliore la qualité et la maintenabilité du code
      - **Tailwind** : Framework CSS utility-first pour des interfaces époustouflantes
      
      &nbsp;
      
      Ces fondamentaux transversaux vous permettront de coder avec plus de confiance et de créer des interfaces professionnelles rapidement.`
    ),
    shortText: 'Apprenez TypeScript et Tailwind, les outils essentiels du développeur moderne.',
    hashtag: ['#TypeScript', '#Tailwind', '#Outils'],
    skills: ['TypeScript', 'Tailwind'],
    courses: ['rncp6-alternance', 'rncp6-alternance-landing'],
  },
  {
    title: 'Coder avec l’intelligence artificielle',
    iconName: 'planet1',
    colorCode: '#88C057',
    text: md.render(
      dedent`Dans ce module, vous apprendrez à **utiliser l’intelligence artificielle comme un assistant de développement**. Vous découvrirez et pratiquerez avec des outils comme [Cursor](https://www.cursor.sh), [ChatGPT](https://chat.openai.com), [Claude](https://www.anthropic.com/), [Mistral](https://mistral.ai/), etc. Vous apprendrez à :
      - Générer et corriger du code plus rapidement
      - Déboguer avec l’aide d’un copilote IA
      - Optimiser vos workflows (documentation, tests, refacto)
      - Lancer des projets plus vite, seul ou en équipe

      &nbsp;

      Ce module vous prépare à travailler avec l’IA de manière concrète, efficace et responsable ; une compétence incontournable pour les développeurs d’aujourd’hui.`
    ),
    shortText:
      'Découvrez comment utiliser l’intelligence artificielle pour coder plus vite, mieux, et avec plus d’impact.',
    hashtag: ['#IA', '#DevAvecIA', '#Cursor', '#ChatGPT', '#Claude'],
    skills: ['Cursor', 'ChatGPT', 'Mistral AI', 'Claude'],
    mainSkills: ['Cursor', 'ChatGPT', 'Mistral AI', 'Claude'],
    courses: [
      'rncp6-fullTime',
      'rncp6-partTime',
      // 'rncp6-alternance',
      'rncp6-fullTime-landing',
      'rncp6-partTime-landing',
      // 'rncp6-alternance-landing',
    ],
    duration: {
      'rncp6-fullTime': '1 semaine',
      'rncp6-partTime': '48 heures',
    },
  },
  {
    title: `Création d’un projet intégrant l’IA`,
    iconName: 'mvpplanet',
    colorCode: '#ADD7DB',
    text: md.render(
      dedent`Au Reacteur, nous accordons une place centrale aux **projets concrets**.

      &nbsp;

      Pendant ce dernier module, vous concevrez, **seul ou en équipe**, un projet complet intégrant des outils d’**intelligence artificielle** comme **Cursor**, **ChatGPT**, **Claude**, **Mistral** ou d'autres **APIs d’IA générative**.

      &nbsp;

      L’objectif : apprendre à collaborer avec l’IA comme un assistant de développement, tout en mobilisant les compétences acquises en **frontend, backend, mobile et API**.

      &nbsp;

      Vous apprendrez à **construire plus vite, mieux, et de manière plus intelligente**, comme dans le monde professionnel d’aujourd’hui.`
    ),
    shortText:
      'Concevez un projet personnel ou en équipe en intégrant des outils d’intelligence artificielle.',
    hashtag: ['#IA', '#ChatGPT', '#Cursor', '#APIs', '#Portfolio'],
    skills: ['Cursor', 'ChatGPT', 'Claude', 'Mistral'],
    mainSkills: ['React', 'Cursor', 'ChatGPT'],
    courses: ['rncp6-fullTime', 'rncp6-fullTime-landing'],
    duration: {
      'rncp6-fullTime': '2 semaines',
      // 'rncp6-alternance': '2 semaines',
    },
  },
  {
    title: 'Applications Mobile iOS et Android',
    iconName: 'appplanet',
    colorCode: '#88C057',
    text: md.render(
      dedent`Dans la continuité de React, **[React Native](https://Meta.github.io/react-native/)** vous permettra de créer des **applications mobiles "cross-platform"** pour iOS et Android.

      &nbsp;

      Pour ce faire, vous développerez un **clone de Airbnb** et aborderez des concepts clés tels que :
      - La navigation avancée avec **Expo Router**
      - L'utilisation de la **géolocalisation** et des **cartes (Maps)**
      - La gestion du stockage local avec **AsyncStorage**
      - L'accès à la **caméra** et l'**upload de photos**

      &nbsp;

      Ce module peut être réalisé **en autonomie**, pendant ou **après la formation**.`
    ),
    shortText:
      'React Native vous permettra de réaliser des applications Mobile « cross-plateform », pour iOS et Android.',
    hashtag: ['#ReactNative', '#Expo', '#Node.js', '#Cloudinary'],
    skills: ['React Native', 'Expo', 'Node.js', 'Cloudinary'],
    mainSkills: ['React Native', 'Expo', 'Cloudinary'],
    courses: [
      'rncp6-fullTime',
      // 'rncp6-alternance',
      'rncp6-fullTime-landing',
      // 'rncp6-alternance-landing',
    ],
    duration: {
      'rncp6-fullTime': 'En e-learning',
      'rncp6-alternance': 'En e-learning',
    },
  },
  {
    title: 'Applications Mobile iOS et Android',
    iconName: 'appplanet',
    colorCode: '#88C057',
    text: md.render(
      dedent`Dans la continuité de React, **[React Native](https://Meta.github.io/react-native/)** vous permettra de créer des **applications mobiles "cross-platform"** pour iOS et Android.

      &nbsp;

      Pour ce faire, vous développerez un **clone de Airbnb** et aborderez des concepts clés tels que :
      - La navigation avancée avec **Expo Router**
      - L'utilisation de la **géolocalisation** et des **cartes (Maps)**
      - La gestion du stockage local avec **AsyncStorage**
      - L'accès à la **caméra** et l'**upload de photos**

      &nbsp;

      Ce module peut être réalisé **en autonomie**, pendant ou **après la formation**.`
    ),
    shortText:
      'React Native vous permettra de réaliser des applications Mobile « cross-plateform », pour iOS et Android.',
    hashtag: ['#ReactNative', '#Expo', '#Node.js', '#Cloudinary'],
    skills: ['React Native', 'Expo', 'Node.js', 'Cloudinary'],
    mainSkills: ['React Native', 'Expo', 'Cloudinary'],
    courses: ['rncp6-partTime', 'rncp6-partTime-landing'],
    duration: {
      'rncp6-partTime': '100 heures',
    },
  },
  {
    title: 'Demo Day',
    iconName: 'demodayplanet',
    colorCode: '#F3D55B',
    text: md.render(
      dedent`Le **Demo Day** est la présentation des projets de fin d'études, organisée le dernier jour de la formation. C'est l'occasion de montrer ce que vous avez créé, **seul ou en équipe**, en intégrant des outils d’**intelligence artificielle**.

      &nbsp;

      Si vous le souhaitez (ce n'est pas obligatoire), vous pourrez **présenter votre projet en live** au Reacteur, devant les autres élèves, les formateurs et des invités.

      &nbsp;

      C’est une excellente opportunité pour :
      - Vous entraîner à la **prise de parole**
      - **Valoriser vos compétences**
      - Rencontrer de potentiels **recruteurs** ou partenaires`
    ),
    shortText:
      'Montrez ce que vous avez été capable de créer, en solo ou en équipe, en intégrant des outils d’intelligence artificielle.',
    hashtag: ['#TalkTalkTalk', '#Portfolio', '#LastDay'],
    /* skills: ['Cursor', 'ChatGPT', 'Claude', 'Mistral'],
    mainSkills: ['React', 'Cursor', 'ChatGPT'], */
    skills: [],
    mainSkills: [],
    courses: ['rncp6-fullTime'],
    duration: {
      'rncp6-fullTime': 'Le dernier jour du bootcamp',
      'rncp6-alternance': 'Le dernier jour du bootcamp',
    },
  },
  {
    title: 'Poursuite en stage ou en alternance',
    iconName: 'internshipplanet',
    colorCode: '#DC9628',
    text: md.render(
      dedent`Après le bootcamp, la majorité de nos élèves poursuivent en **alternance** pour obtenir un **Titre RNCP de niveau 6 (Bac+3/4)**. C'est l'occasion idéale d'acquérir une expérience professionnelle solide tout en continuant à apprendre.

      &nbsp;

      Nous vous accompagnons activement dans votre recherche : nous **mettons en avant votre profil** auprès de notre réseau d'entreprises partenaires et nous vous coachons pour **préparer vos entretiens**.

      &nbsp;

      Si vous préférez, une convention de **stage (jusqu'à 6 mois)** est également possible. Les stages sont rémunérés (environ 1.000€/mois).`
    ),
    hashtag: ['#Alternance', '#Stage', '#BackToWork', '#ToTheMoon'],
    courses: ['rncp6-fullTime', 'rncp6-partTime'],
    skills: [],
    duration: {
      'rncp6-fullTime': '18 mois en alternance ou 6 mois de stage',
      'rncp6-partTime': '18 mois en alternance ou 6 mois de stage',
    },
  },
  {
    title: 'Périodes en alternance',
    iconName: 'internshipplanet',
    colorCode: '#DC9628',
    text: md.render(
      dedent`Pendant vos périodes en alternance, en fonction du programme de formation qui vous aura été attribué (selon votre niveau de compétences et la demande de votre entreprise), vous aborderez des notions avancées telles que :
      - **TypeScript**
      - **Backend avancé** : Tests unitaires, sécurisation de serveur, Prisma, Strapi, SQLite, PostgreSQL, etc.
      - **React avancé** : Redux, Next.js, SWR, React Testing Library, Tailwind, WebSockets, etc.
      - Utilisation de l'**Intelligence Artificielle** (OpenAI, Mistral, etc.)`
    ),
    shortText:
      'Vous aborderez des notions avancées telles que Typscript, les tests, Next.js, Tailwind, le déploiement sur les stores, Strapi, les Push Notifications, etc.',
    hashtag: ['#AdvancedSkills', '#PushTheLimits', '#AI'],
    courses: [],
    skills: ['TypeScript', 'Next.js', 'Tailwind', 'Strapi'],
    duration: {
      'rncp6-alternance': 'Rythme : 3 sem. en entreprise, 1 sem. en formation',
      'rncp6-alternance-landing': '3 sem. en entreprise, 1 sem. en formation',
    },
  },
  // RNCP5 e-learning
  {
    title: 'Frontend',
    shortTitle: 'Frontend (70h)',
    iconName: 'integrationplanet',
    colorCode: '#92A8DD',
    text: md.render(
      dedent`**HTML** et **CSS** sont les piliers de la création de pages Web. Dans ce module, vous apprendrez les **meilleures pratiques de mise en page**, d'**optimisation** et de **référencement**.

      &nbsp;

      Vous mettrez en pratique vos compétences en répliquant des sites populaires comme [**Marmiton**](https://www.marmiton.org/) ou [**Trip Advisor**](https://www.tripadvisor.fr/).`
    ),
    shortText: 'Vous apprendrez les meilleures pratiques de mise en page et d’optimisation Web.',
    hashtag: ['#HTML', '#CSS', '#Responsive'],
    skills: ['HTML', 'CSS', 'JS'],
    courses: ['rncp5-e-learning', 'rncp5-e-learning-landing'],
    duration: {
      'rncp5-e-learning': '70 heures',
    },
  },
  {
    title: 'Backend',
    shortTitle: 'Backend (70h)',
    iconName: 'serveurplanet',
    colorCode: '#F9C38A',
    text: md.render(
      dedent`Une fois l'algorithmique maîtrisée, vous serez en mesure de comprendre le fonctionnement d'un **serveur**. Grâce au framework **[Strapi](https://strapi.io/)**, vous apprendrez les bases du **backend** :
      - Création et personnalisation des **routes HTTP**
      - Bases de données **[SQLite](https://www.sqlite.org/)** et **[PostgreSQL](https://www.postgresql.org/)**
      - Principes d'**authentification** et d'**autorisation**
      - **Paiement en ligne**
      - Hébergement du serveur`
    ),
    shortText: "Vous serez en mesure de comprendre le fonctionnement d'un serveur.",
    hashtag: ['#Strapi', '#SQLite', '#PostgreSQL'],
    skills: ['Strapi', 'SQLite', 'PostgreSQL'],
    courses: ['rncp5-e-learning', 'rncp5-e-learning-landing'],
    duration: {
      'rncp5-e-learning': '70 heures',
    },
  },
  {
    title: 'Framework Vue.js',
    shortTitle: 'Vue.js (175h)',
    iconName: 'siteplanet',
    colorCode: '#D75A4A',
    text: md.render(
      dedent`**[Vue.js](https://vuejs.org/)** est un **framework JavaScript progressif** qui facilite la création d'interfaces utilisateur interactives pour les applications Web.

      &nbsp;

      Il se distingue par sa **simplicité** et sa **flexibilité**, vous offrant un moyen efficace de construire des applications modernes à l'aide de **composants réutilisables**.`
    ),
    shortText:
      'Vous apprendrez à créer des interfaces utilisateur interactives pour les applications Web.',
    hashtag: ['#Vue.js', '#Netlify'],
    skills: ['Vue.js', 'Netlify'],
    courses: ['rncp5-e-learning', 'rncp5-e-learning-landing'],
    duration: {
      'rncp5-e-learning': '175 heures',
    },
  },
  {
    title: 'Préparation au projet professionnel',
    shortTitle: 'Projet professionnel (35h)',
    iconName: 'demodayplanet',
    colorCode: '#F3D55B',
    text: md.render(
      dedent`Ce module vous aide à préparer votre **projet professionnel** :
      - Rédiger un **CV** et une **lettre de motivation** efficaces
      - Bien se préparer pour un **entretien**
      - Quoi répondre aux **questions fréquentes**
      - En route pour **l'alternance** ?
      - Optimiser sa **présence en ligne** en utilisant les réseaux sociaux`
    ),
    shortText: 'Conseils CV, lettre de motivation, entretien, présence en ligne.',
    hashtag: ['#LinkedIn'],
    skills: ['LinkedIn', 'CV', 'Entretien'],
    courses: ['rncp5-e-learning', 'rncp5-e-learning-landing'],
    duration: {
      'rncp5-e-learning': '35 heures',
    },
  },
  {
    title: 'Framework React.js (module optionnel)',
    shortTitle: 'React.js (175h)',
    isOptionnal: true,
    /* iconName: 'appplanet',
    colorCode: '#88C057', */
    iconName: 'mvpplanet',
    colorCode: '#4eb4ce',
    text: md.render(
      dedent`**[React](https://fr.reactjs.org/)** est la **librairie JavaScript la plus populaire et demandée** sur le marché. Créée par **Meta**, elle est utilisée par les plus grandes entreprises tech : **Netflix, Dropbox, Airbnb, leboncoin**, etc.

      &nbsp;

      Grâce à son système de **composants**, React permet de créer rapidement des **interfaces utilisateur ultra-puissantes**. Vous mettrez en pratique vos nouvelles compétences en réalisant des clones simplifiés de sites comme :
      - [**Deliveroo**](https://deliveroo.fr/fr/)
      - [**Vinted**](https://www.vinted.fr/)
      - [**Marvel**](https://www.marvel.com/)
      
      &nbsp;

      Ce module est réalisé **en e-learning**, pendant la formation.`
    ),
    shortText:
      'Avec React et son système de composants, vous pourrez créer rapidement des interfaces ultra-puissantes',
    hashtag: ['#React', '#ViteJS'],
    skills: ['React', 'ViteJS'],
    mainSkills: ['React', 'ViteJS'],
    // courses: ['rncp5-e-learning', 'rncp5-e-learning-landing'],
    courses: [],
    duration: {
      'rncp5-e-learning': '175 heures',
    },
  },
  {
    title: 'Stage en entreprise (facultatif)',
    shortTitle: 'Stage (facultatif)',
    iconName: 'internshipplanet',
    colorCode: '#DC9628',
    text: md.render(
      dedent`Suite à votre formation au Reacteur, vous bénéficierez, si vous le souhaitez, d'une convention de stage afin de passer votre titre RNCP de Développeur Web et Web Mobile. Nous attirons votre attention sur le fait que le coût du passage du titre n'est pas inclus dans le prix de la formation ; il vous en coûtera 600 euros, si vous souhaitez le passer, et nous vous invitons à nous communiquer cette information lors de votre inscription.`
    ),
    hashtag: ['#BackToWork', '#ToTheMoon'],
    courses: ['rncp5-e-learning'],
    skills: [],
    duration: {
      'rncp5-e-learning': '2 mois',
    },
  },
  // FULL-STACK
  {
    title: 'Concevoir une application Web ou Mobile',
    iconName: 'travailplanet',
    colorCode: '#DC9628',
    text: md.render(
      dedent`Ce module couvre la **conception d'une application de A à Z** :
      - **Analyse des fonctionnalités** et identification des tâches de développement (veille, étude des besoins, contraintes réglementaires : RGPD, accessibilité, éco-conception).
      - **Conception d'interfaces utilisateur (UI)** interactives, incluant la création de maquettes, la prise en compte de l'éco-conception, du RGPD et de l'accessibilité.`
    ),
    courses: ['full-stack'],
  },
  {
    title: 'Piloter un projet de développement d’application Web ou Mobile',
    iconName: 'JSplanet',
    colorCode: '#868C9B',
    text: md.render(
      dedent`Apprenez à **gérer un projet de développement** en utilisant la **méthode Agile** :
      - **Planification du projet** : identification des ressources, planification des sprints, coordination de l'équipe.
      - **Gestion de la qualité** : définition des KPIs, élaboration d'une stratégie de tests, et mise en place de versioning avec Git.`
    ),
    courses: ['full-stack'],
  },
  {
    title: `Développer le back-end sécurisée d'une application Web ou Mobile`,
    iconName: 'serveurplanet',
    colorCode: '#F9C38A',
    text: md.render(
      dedent`Ce module est dédié au **développement backend** :
      - Développement de l'**API** : rédaction du code, conception de la base de données (**SQL ou NoSQL**), implémentation des routes et contrôleurs, et **sécurisation de l'API**.
      - **Gestion des fonctionnalités serveur** : documentation de l'API, manipulation des données, et mise en place de tests.`
    ),
    courses: ['full-stack'],
  },
  {
    title: `Développer le front-end d'une application Web ou Mobile`,
    iconName: 'integrationplanet',
    colorCode: '#92A8DD',
    text: md.render(
      dedent`Concentrez-vous sur le **développement frontend** en utilisant différentes approches :
      - **Développement Web ou Mobile** : en codant, en utilisant un framework, ou des outils **No-Code**.
      - **Intégration de l'expérience utilisateur (UX)**, création d'une interface en **responsive design**, et respect des bonnes pratiques de sécurité.
      - **Gestion des fonctionnalités utilisateur** : documentation, détection et correction des bugs.`
    ),
    courses: ['full-stack'],
  },
  {
    title: `Déployer une application Web ou Mobile`,
    iconName: 'demodayplanet',
    colorCode: '#F3D55B',
    text: md.render(
      dedent`Apprenez à **mettre en production** vos applications :
      - **Déploiement et automatisation** : mise en production dans une démarche **DevOps** et automatisation du déploiement.
      - **Optimisation des performances** : gestion proactive des performances, des erreurs, et définition d'axes d'amélioration.`
    ),
    courses: ['full-stack'],
  },
  {
    title: 'Fondamentaux du Backend',
    shortTitle: 'Fondamentaux Backend',
    iconName: 'integrationplanet',
    colorCode: '#5B8DEE',
    text: md.render(
      dedent`Apprenez les bases solides du développement backend avec les technologies essentielles :
      - **Prisma** : ORM moderne pour interroger vos bases de données
      - **SQLite** : Base de données embarquée idéale pour le développement
      - **PostgreSQL** : Base de données relationnelle robuste et professionnelle

      &nbsp;

      Ces fondamentaux vous permettront de gérer efficacement vos données et de construire des APIs fiables.`
    ),
    shortText: 'Maîtrisez les fondamentaux du backend avec Prisma, SQLite et PostgreSQL.',
    hashtag: ['#Backend', '#Database', '#Prisma'],
    skills: ['Prisma', 'SQLite', 'PostgreSQL'],
    courses: ['rncp6-alternance', 'rncp6-alternance-landing'],
  },
  {
    title: 'Backend avancé & DevOps',
    shortTitle: 'Backend avancé',
    iconName: 'JSplanet',
    colorCode: '#2E7D32',
    text: md.render(
      dedent`Progressez vers une maîtrise avancée du backend et découvrez les outils DevOps :
      - **Strapi** : CMS headless pour gérer votre contenu facilement
      - **NestJS** : Framework backend robuste et scalable basé sur TypeScript
      - **Docker** : Containerisation pour déployer vos applications partout

      &nbsp;

      À ce stade, vous serez capables de construire des architectures backend professionnelles, maintenables et déployables en production.`
    ),
    shortText: 'Explorez Strapi, NestJS et Docker pour une expertise backend de haut niveau.',
    hashtag: ['#AdvancedBackend', '#DevOps', '#Production'],
    skills: ['Strapi', 'NestJS', 'Docker'],
    courses: ['rncp6-alternance', 'rncp6-alternance-landing'],
  },
  {
    title: 'Frontend avancé & State Management',
    shortTitle: 'Frontend avancé',
    iconName: 'siteplanet',
    colorCode: '#F57C00',
    text: md.render(
      dedent`Maîtrisez les technologies frontend les plus demandées en 2025 :
      - **Redux** : Gestion d'état centralisée et prévisible
      - **Next.js** : Framework React pour les applications modernes et performantes
      - **SWR** : Gestion intelligente des données et du cache côté client
      - **VueJS** : Alternative progressive à React pour construire des interfaces
      - **Socket.io** : Communication en temps réel pour des apps interactives

      &nbsp;

      Vous serez en mesure de créer des applications frontend sophistiquées, performantes et offrant une expérience utilisateur exceptionnelle.`
    ),
    shortText:
      'Maîtrisez Redux, Next.js, Tailwind et Socket.io pour construire des frontends modernes et performants.',
    hashtag: ['#AdvancedFrontend', '#StateManagement', '#RealTime'],
    skills: ['React', 'Redux', 'Next.js', 'Vue.js'],
    courses: ['rncp6-alternance', 'rncp6-alternance-landing'],
  },
  {
    title: 'Tests & Qualité de code',
    shortTitle: 'Tests & Qualité',
    iconName: 'mvpplanet',
    colorCode: '#7B1FA2',
    text: md.render(
      dedent`Garantissez la qualité et la fiabilité de votre code :
      - **Jest** : Framework de test puissant et complet pour JavaScript
      - **RTL (React Testing Library)** : Tester vos composants React comme les vrais utilisateurs

      &nbsp;

      Les tests ne sont pas une option, c'est une compétence professionnelle essentielle. À la fin de ce module, vous écrirez du code couvert par des tests robustes, maintenable et confiance en production.`
    ),
    shortText: 'Écrivez des tests avec Jest et RTL pour du code production-ready.',
    hashtag: ['#Testing', '#Quality', '#BestPractices'],
    skills: ['Jest', 'RTL'],
    courses: ['rncp6-alternance', 'rncp6-alternance-landing'],
  },
  {
    title: 'Applications Mobile iOS et Android',
    iconName: 'appplanet',
    colorCode: '#88C057',
    text: md.render(
      dedent`Progressez vers des **bonnes pratiques avancées** en développement mobile avec **[React Native](https://Meta.github.io/react-native/)** et **[Expo](https://expo.dev/)**. Créez des **applications mobiles "cross-platform"** performantes et maintenables pour iOS et Android.

      &nbsp;

      Vous consoliderez vos compétences en construisant un **clone de Airbnb** et maîtriserez les concepts clés de la production mobile :
      - La navigation avancée avec **Expo Router**
      - L'utilisation de la **géolocalisation** et des **cartes (Maps)**
      - La gestion du stockage local avec **AsyncStorage**
      - L'accès à la **caméra** et l'**upload de photos**
      - Les **bonnes pratiques de performance** et d'optimisation
      - Le **déploiement sur les stores** (App Store et Google Play)

      &nbsp;

      Ce module est réalisé **en e-learning**, pendant la formation.`
    ),
    shortText:
      'Maîtrisez React Native et Expo pour créer des applications mobiles cross-platform pour iOS et Android.',
    hashtag: ['#ReactNative', '#Expo', '#BestPractices', '#Cloudinary'],
    skills: ['React Native', 'Expo'],
    mainSkills: ['React Native', 'Expo'],
    courses: ['rncp6-alternance', 'rncp6-alternance-landing'],
    duration: {},
  },
  {
    title: 'Coder avec l’intelligence artificielle',
    iconName: 'planet1',
    colorCode: '#88C057',
    text: md.render(
      dedent`Dans ce module, vous apprendrez à **utiliser l’intelligence artificielle comme un assistant de développement**. Vous découvrirez et pratiquerez avec des outils comme [Cursor](https://www.cursor.sh), [ChatGPT](https://chat.openai.com), [Claude](https://www.anthropic.com/), [Mistral](https://mistral.ai/), etc. Vous apprendrez à :
      - Générer et corriger du code plus rapidement
      - Déboguer avec l’aide d’un copilote IA
      - Optimiser vos workflows (documentation, tests, refacto)
      - Lancer des projets plus vite, seul ou en équipe

      &nbsp;

      Ce module vous prépare à travailler avec l’IA de manière concrète, efficace et responsable ; une compétence incontournable pour les développeurs d’aujourd’hui.`
    ),
    shortText:
      'Découvrez comment utiliser l’intelligence artificielle pour coder plus vite, mieux, et avec plus d’impact.',
    hashtag: ['#IA', '#DevAvecIA', '#Cursor', '#ChatGPT', '#Claude'],
    skills: ['Cursor', 'ChatGPT', 'Mistral AI', 'Claude'],
    mainSkills: ['Cursor', 'ChatGPT', 'Claude'],
    courses: ['rncp6-alternance', 'rncp6-alternance-landing'],
    duration: {},
  },
];

export default ProgramData;
